export const AUTH = {
  TOKEN_EXPIRED:
    'Tu sesión expiró. Por favor verificá tu información de usuario e iniciá sesión nuevamente.',
  USER_DATA_ERROR: 'No pudimos traer la información del usuario',
  LOGIN_UNAUTHORIZED:
    'No pudimos iniciar tu sesión. Verificá los datos ingresados y probá nuevamente.',
  RENEW_TOKEN_ERROR: 'No pudimos renovar tu sesión, por favor intentá nuevamente',
  PERMISSION_ERROR: 'No pudimos traer los permisos de tu usuario',
  IMPERSONATE_UNAUTHORIZED:
    'No pudimos impersonarte. Hay algún error en los datos. Volvé a intentar por favor',
};

export const SERVER = {
  500: 'Ocurrió un problema en el servidor de datos',
};

export const ROUTER_BASE_PATH = '/prestadores';
export const DOC_24_TITLE = 'Agenda de Turnos';
export const HOME = ROUTER_BASE_PATH;
export const SERVER_HOME = '/'; // La infra del servidor en aws apunta a "/" cuando para nosotros es "/prestadores", por eso debemos contemplarlo.
export const ROUTER_BASE_PATH_MOBILE = '/';

export const FULL_WIDTH_ROUTES = [
  {
    id: 'TRAMITES_ONLINE',
    route: '/tramitesonline',
  },
  {
    id: 'PAGOS_FULL',
    route: '/pagosFull',
  },
  {
    id: 'FACTURAS_FULL',
    route: '/facturasFull',
  },
  {
    id: 'CONSULTORIOS_FULL',
    route: '/consultoriosFull',
  },
  {
    id: 'DATOS_IMPOSITIVOS',
    route: '/informacionutil/datos-impositivos',
  },
];

export const smgCenters = [
  1632, 26564, 64677, 85316, 210252, 196559, 217747, 226756, 122803, 196561, 206939, 213729, 143774,
  1763, 2086, 55060, 99785, 182730, 240895, 1128, 135464, 187243, 211421, 69669, 249704, 189612,
  259542, 124248, 211732, 31244, 75470, 78363, 78452, 85401, 118209, 124248, 206939,
];

export const CHARACTERS_REMAINING_FIELD = 250;
